var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle,consistent-return,default-case */
import React from 'react';
import cuid from 'cuid';
import { Button } from '@empiriecom/module-components';
import styled, { css, ThemeProvider } from 'styled-components';
import useIcon from '@empiriecom/module-components/utils/getIcon';
import { buttonTheme } from '@empiriecom/module-components/Button/theme';
import setTargetCookie from '../../utils/setCookie';
import buildLinkWithArguments from '../../utils/buildLinkWithArguments';
import iconPreparer from '../../utils/iconPreparer';
import useConfig from '../hooks/useConfig';
export var LinkButtinTestIds;
(function (LinkButtinTestIds) {
    LinkButtinTestIds["LinkByButtonId"] = "cmsButtonLink__testid";
})(LinkButtinTestIds || (LinkButtinTestIds = {}));
var StyledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    color: ", ";\n    ", "\n  }\n"], ["\n  &&& {\n    color: ",
    ";\n    ",
    "\n  }\n"])), function (_a) {
    var button = _a.theme.component.button, layout = _a.layout;
    return button[layout || 'default'].color.text;
}, function (_a) {
    var withicon = _a.withicon, iconplacement = _a.iconplacement;
    return withicon === 'true' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: relative;\n        text-transform: none;\n        ", ": 1.5rem;\n        & svg {\n          position: absolute;\n          top: 50%;\n          width: 0.875rem;\n          height: 0.875rem;\n          ", ": 0.25rem;\n          transform: translate(0, -50%);\n        }\n      "], ["\n        position: relative;\n        text-transform: none;\n        ", ": 1.5rem;\n        & svg {\n          position: absolute;\n          top: 50%;\n          width: 0.875rem;\n          height: 0.875rem;\n          ", ": 0.25rem;\n          transform: translate(0, -50%);\n        }\n      "])), iconplacement === 'left' ? 'padding-left' : 'padding-right', iconplacement === 'left' ? 'left' : 'right');
});
var buttonLayoutVariants = function (type) {
    var test = type.match(/base|greyDark|greyLight/g) ? 'default' : type;
    return test;
};
var LinkByButton = function (_a) {
    var _b;
    var contentData = _a.contentData, _c = _a.componentKey, componentKey = _c === void 0 ? cuid() : _c;
    var buttonText = contentData.field_text, _d = contentData.field_link, link = _d === void 0 ? '' : _d, _e = contentData.field_layout, layout = _e === void 0 ? 'default' : _e, _f = contentData.field_icon, iconType = _f === void 0 ? '' : _f, linkTarget = contentData.field_link_target, iconPlacement = contentData.field_direction, persistTarget = contentData.field_persist_target, 
    /* eslint-disable @typescript-eslint/naming-convention */
    field_tracking = contentData.field_tracking, field_link_anchor = contentData.field_link_anchor, field_link_highlight = contentData.field_link_highlight, field_link_searchfilter = contentData.field_link_searchfilter, field_bonus_number = contentData.field_bonus_number;
    var config = useConfig();
    var prepareIcon = iconPreparer(iconType, (_b = config === null || config === void 0 ? void 0 : config.drupalIconMapper) === null || _b === void 0 ? void 0 : _b.values);
    var Icon = prepareIcon && useIcon(prepareIcon);
    var IconElement = Icon && React.createElement(Icon, null);
    var onClickProp = persistTarget && { onClick: function () { return setTargetCookie(link); } };
    var cLayout = buttonLayoutVariants(layout);
    return (React.createElement(ThemeProvider, { theme: buttonTheme },
        React.createElement(StyledButton, __assign({ layout: cLayout, key: "custom-button-" + componentKey, "data-testid": LinkButtinTestIds.LinkByButtonId, to: buildLinkWithArguments(link, {
                field_tracking: field_tracking,
                field_link_anchor: field_link_anchor,
                field_link_highlight: field_link_highlight,
                field_link_searchfilter: field_link_searchfilter,
                field_bonus_number: field_bonus_number,
            }), 
            /* mgruben - this property is not yet ready to use as link target by core-button */
            target: linkTarget, asLink: true, withicon: (iconType !== '').toString(), iconplacement: iconPlacement }, onClickProp), iconPlacement === 'left' ? (React.createElement(React.Fragment, null,
            iconType && IconElement,
            buttonText)) : (React.createElement(React.Fragment, null,
            buttonText,
            iconType && IconElement)))));
};
export default LinkByButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map